





























import VueOptions from '@utils/VueOptions'
import Draggable from 'vuedraggable'

settings =
  name: 'MediaSorter'

  vue:
    props: ['media', 'form']
    components: { Draggable }

export default VueOptions.vue settings
